import React from 'react'
import createSvgIcon from '../utilities/createSvgIcon'

export default createSvgIcon(
  <>
    <path d="M14.3672 16L15 16.6328V18H3V16H14.3672ZM16.6719 11L16.6787 11.501C15.7696 11.1179 14.6801 11.2966 13.9395 12.0371C13.659 12.3176 13.4592 12.6481 13.3398 13H3V11H16.6719ZM21 6V8H20.5146C20.1154 7.74169 19.6391 7.59304 19.1279 7.59961C18.6392 7.60605 18.1848 7.75247 17.8027 8H3V6H21Z" />
    <path
      d="M19.1601 10.0994L19.2322 15.5723M15.7066 13.8044L19.2421 17.34M19.2322 17.33L22.7678 13.7944"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="2"
    />
  </>,
  'NotesDownload',
)
